import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	BoxHeader,
	Container,
	Content,
	Description,
	FooterMicroService,
	FooterPlan,
	Header,
	Label,
	Logo,
	Pros,
	Title,
	Wrapper,
} from "./styles";

import CheckIcon from "@material-ui/icons/Check";
import MicroServiceCard from "./MicroServicesCard";
import PlanCard from "./PlanCard";
import Steps from "../Steps";
import { Product } from "../../utils/constants";
import { setProductForCheckout } from "../../store/modules/billingPlan/actions";
import { removeStorageKey } from "../../utils";

const FluxPromotional = () => {
	const dispatch = useDispatch();

	const { dataMicroServiceFluxPromo, dataPlanFluxPromo } = useSelector((state) => state.billingPlan);

	const [oneProduct, setOneProduct] = useState(null);
	const [plans, setPlans] = useState(null);
	const [microServices, setMicroServices] = useState(null);
	const [productName, setProductName] = useState("Loja");

	const steps = [{ label: "Identificação" }, { label: "Pagamento" }, { label: "Conclusão" }];

	useEffect(() => {
		let data = [];

		if (
			(dataMicroServiceFluxPromo && dataMicroServiceFluxPromo.length === 1) ||
			(dataPlanFluxPromo && dataPlanFluxPromo.length === 1)
		) {
			const [productData] = dataMicroServiceFluxPromo || dataPlanFluxPromo;
			const objDataProduct = {
				title: productData.ds_micro_service || productData.title,
				description: productData.ds_text_labs,
				descriptionPros: productData.ds_pros_list || productData.description_pros,
			};

			setOneProduct(objDataProduct);
			changeProductName(productData.title || productData.ds_micro_service);

			if (dataPlanFluxPromo) dispatch(setProductForCheckout(productData, Product.PLAN));

			if (dataMicroServiceFluxPromo)
				dispatch(
					setProductForCheckout(
						[productData.cd_micro_service],
						Product.MICRO_SERVICE
					)
				);

			return;
		}

		if (dataPlanFluxPromo && dataPlanFluxPromo.length > 1) {
			dataPlanFluxPromo.forEach((element) => {
				data.push({
					title: element.title,
					description: element.ds_text_labs,
					descriptionPros: element.description_pros,
					price: element.installment_options[
						element.installment_options.length - 1
					].price,
					banner: element.banner_url,
					id: element.id_plan,
					cdPlan: element.cd_plan,
					dataComplete: dataPlanFluxPromo,
				});
			});

			setPlans(data);
			return;
		}

		if (dataMicroServiceFluxPromo && dataMicroServiceFluxPromo.length > 1) {
			dataMicroServiceFluxPromo.forEach((element) => {
				data.push({
					title: element.ds_micro_service,
					description: element.ds_text_labs,
					descriptionPros: element.ds_pros_list,
					price: element.price_annual / 12,
					banner: element.url_photo,
					id: element.id_micro_service,
					cdMicroService: element.cd_micro_service,
					dataComplete: dataMicroServiceFluxPromo,
				});
			});

			setMicroServices(data);
		}
		// eslint-disable-next-line
	}, [dataMicroServiceFluxPromo, dataPlanFluxPromo, dispatch]);

	useEffect(() => {
		if (dataMicroServiceFluxPromo) {
			const keyListInStorage = ["CACHEDPLAN", "PLANSELECTED", "CDPROMOTIONAL", "LISTPLAN"];

			for (let value of keyListInStorage) {
				if (sessionStorage.getItem(value) || localStorage.getItem(value)) {
					removeStorageKey(value);
				}
			}
		}

		if (dataPlanFluxPromo) {
			const keyListInStorage = ["flow-checkout", "COMBO_PROMOTIONAL_FLOW", "COMBO_PROMOTIONAL"];

			for (let value of keyListInStorage) {
				if (sessionStorage.getItem(value) || localStorage.getItem(value)) {
					removeStorageKey(value);
				}
			}

			if (dataPlanFluxPromo.length > 1) {
				removeStorageKey("PLANSELECTED");
			}
		}
	}, [dataMicroServiceFluxPromo, dataPlanFluxPromo]);

	const changeProductName = useCallback((name) => {
		setProductName(name);
	}, []);

	return (
		<Container>
			<Content>
				<Header>
					<BoxHeader>
						<Logo />
						<Title>{productName}</Title>
					</BoxHeader>
					<Steps steps={steps} active={0} />
				</Header>

				{oneProduct && (
					<div>
						<Description>{oneProduct.description}</Description>
						{oneProduct.descriptionPros.map((item) => (
							<Wrapper key={item}>
								<CheckIcon size={24} />
								<Pros>{item}</Pros>
							</Wrapper>
						))}
					</div>
				)}
				{Boolean(plans) && (
					<FooterPlan size={plans.length}>
						{plans.map((item) => (
							<PlanCard
								key={item.title}
								data={item}
								onChange={(item) =>
									changeProductName(item)
								}
							/>
						))}
					</FooterPlan>
				)}
				{Boolean(microServices) && (
					<FooterMicroService size={microServices.length}>
						{microServices.map((item) => (
							<MicroServiceCard
								key={item.title}
								data={item}
								onChange={(item) =>
									changeProductName(item)
								}
							/>
						))}
					</FooterMicroService>
				)}
				<Label>Deixe o TradeMap te ajudar a dar o próximo passo</Label>
			</Content>
		</Container>
	);
};

export default FluxPromotional;
